import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import StyledTableCell from "../../StyledTable/StyledTableCell/StyledTableCell";
import StyledTableRow from "../../StyledTable/StyledTableRow/StyledTableRow";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { formatCurrency } from "../../../../../../utils/formatHelpers";
import { getSumOfArrayOfObjects } from "../../../../../../utils/calcHelpers";

export default function StagedComchecksTable({ 
  activeLoad, 
  stagedComchecksArray, 
  setComcheckToEdit,
  comcheckIdUnderReview,
  step,
  setStep,
  handleDeleteStagedComcheck
}) {
  const [requestedSum, setRequestedSum] = useState("");
  const [feeSum, setFeeSum] = useState("");
  const [totalSum, setTotalSum] = useState("");

  const handleEdit = (row) => {
    setComcheckToEdit(row);
    setStep(1);
  };

  useEffect(() => {
    const requestedAmounts = getSumOfArrayOfObjects(stagedComchecksArray, "requestedAmount");
    const fees = getSumOfArrayOfObjects(stagedComchecksArray, "comcheckFee");

    setRequestedSum(requestedAmounts);
    setFeeSum(fees);
    setTotalSum(requestedAmounts - fees);

  }, [stagedComchecksArray]);

  return (
    <Box>
      <Typography variant="body1" color="primary.60">
        COMCHECKS FOR LOAD #{activeLoad.id}
      </Typography>
      <TableContainer sx={{ borderRadius: "8px", marginTop: "10px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "black_solid.20" }}>
            <StyledTableRow>
              <StyledTableCell>
                <Typography variant="subhead2" color="black_solid.60">
                  Reason
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="subhead2" color="black_solid.60">
                  Requested Amount
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="subhead2" color="black_solid.60">
                  Fee
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography variant="subhead2" color="black_solid.60">
                  Total
                </Typography>
              </StyledTableCell>
              <StyledTableCell />
            </StyledTableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: "black_solid.10" }}>
            {stagedComchecksArray.map((row, i) => (
              row.tempId !== comcheckIdUnderReview &&
                  <StyledTableRow key={`comcheck-row-${i}`}>
                    <StyledTableCell>
                      <Typography variant="body1" color="black_solid.80">
                        {row.reason}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Typography variant="body1" color="black_solid.80">
                        {formatCurrency(row.requestedAmount, 2)}
                      </Typography>
                    </StyledTableCell> 
                    <StyledTableCell>
                      <Typography variant="body1" color="black_solid.80">
                        {formatCurrency(row.comcheckFee, 2)}
                      </Typography>
                    </StyledTableCell> 
                    <StyledTableCell>
                      <Typography variant="body1" color="black_solid.80">
                        {formatCurrency(row.totalAmount, 2)}
                      </Typography>
                    </StyledTableCell> 
                    <StyledTableCell>
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ marginRight: "10px" }}>
                          <InlineIconButton 
                            onClick={() => handleDeleteStagedComcheck(row)} 
                            icon={DeleteIcon}
                            color="grey"
                          />
                        </Box>
                        <Box>
                          <InlineIconButton 
                            onClick={() => handleEdit(row)}
                            icon={EditIcon}
                            color="grey"
                          />
                        </Box>
                      </Box>
                    </StyledTableCell>     
                  </StyledTableRow>
            ))}
            {step === 3 &&
              <StyledTableRow>
                <StyledTableCell sx={{ backgroundColor: "background.paper" }}>
                  <Typography variant="subhead2" color="black_solid.60">
                    Totals
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ backgroundColor: "background.paper" }}>
                  <Typography variant="h2" color="black_solid.60">
                    {formatCurrency(requestedSum, 2)}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ backgroundColor: "background.paper" }}>
                  <Typography variant="h2" color="black_solid.80">
                    {formatCurrency(feeSum, 2)}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ backgroundColor: "background.paper" }}>
                  <Typography variant="h2" color="black_solid.80">
                    {formatCurrency(totalSum, 2)}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell sx={{ backgroundColor: "background.paper" }}/>
              </StyledTableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

StagedComchecksTable.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  stagedComchecksArray: PropTypes.array.isRequired,
  setComcheckToEdit: PropTypes.func,
  comcheckIdUnderReview: PropTypes.number,
  step: PropTypes.number,
  setStep: PropTypes.func,
  handleDeleteStagedComcheck: PropTypes.func
};